module.exports = __webpack_public_path__ + "static/media/siddharth-big-banyan-tree-trip-01.4fa42f63.png";